import React, { useState } from "react";
import { useLocation } from "react-router-dom";

import "./layout.scss";

// components
import { Navbar } from "components/hocs/navbar/Navbar";
import { MiCuentaNavbar } from "components/hocs/navbar/MiCuentaNavbar";
import { Footer } from "components/hocs/footer/Footer";
import { ImmersiveNavbar } from "components/hocs/navbar/ImmersiveNavbar";
import { ImmersiveFooter } from "components/hocs/footer/ImmersiveFooter";
import { TempTokenCountdown } from "components/hocs/navbar/TempTokenCountdown";

type Props = {
  children: JSX.Element;
};

export const Layout = ({ children }: Props) => {
  const location = useLocation();
  const [openCityModal, setOpenCityModal] = useState(false);

  return (
    <div className="root">
      {location.pathname.startsWith("/mi-cuenta") && (
        <MiCuentaNavbar setOpenCityModal={setOpenCityModal} />
      )}
      {location.pathname.startsWith("/solicita-tu-credito") && (
        <ImmersiveNavbar />
      )}
      {(
        !location.pathname.startsWith("/mi-cuenta") &&
        !location.pathname.startsWith("/solicita-tu-credito")
      ) && (
        <Navbar setOpenCityModal={setOpenCityModal} />
      )}
      <span className="bordeNav" />
      <TempTokenCountdown />
      <div className="main m_t_md_mobile">
        <div className="layout-container">{children}</div>
        {location.pathname.startsWith("/solicita-tu-credito") && (
          <ImmersiveFooter />
        )}
        {!location.pathname.startsWith("/solicita-tu-credito") && (
          <Footer />
        )}
      </div>
    </div>
  );
};
